export function getFileLimits(state) {

    // start from defaults
    let velicinaDatoteka = state?.velicinaDatoteka;
    let brojDatoteka = state?.brojDatoteka;

    let usluga = state?.usluga ?? null;
    if (usluga != null) {
        // normalize to number if it's a numeric string
        if (typeof usluga === "string" && usluga.trim() !== "") {
            const n = Number(usluga);
            usluga = Number.isFinite(n) && Number.isInteger(n) ? n : null;
        } else if (!Number.isInteger(usluga)) {
            usluga = null;
        }
    }

    const map = {
        3:  { vel: "rgfiVelicinaDatoteka", broj: "rgfiBrojDatoteka" },
        6:  { vel: "epassVelicinaDatoteka" },
        16: { broj: "ppBrojDatoteka" },
        52: { vel: "neprofitniVelicinaDatoteka", broj: "neprofitniBrojDatoteka" },
        53: { vel: "proracuniVelicinaDatoteka", broj: "proracuniBrojDatoteka" },
        56: { vel: "ponipVelicinaDatoteka", broj: "ponip4BrojDatoteka" },
        57: { vel: "ponipVelicinaDatoteka" },
        58: { vel: "ponipVelicinaDatoteka" },
        11: { vel: "ponipVelicinaDatoteka" },
        12: { vel: "ponipVelicinaDatoteka" },
        13: { vel: "ponipVelicinaDatoteka" },
        100: { vel: "steVelicinaDatoteka", broj: "steBrojDatoteka" },
        101: { vel: "steVelicinaDatoteka", broj: "steBrojDatoteka" },
        102: { vel: "steVelicinaDatoteka", broj: "steBrojDatoteka" },
        103: { vel: "steVelicinaDatoteka", broj: "steBrojDatoteka" }
    };

// handle exact matches first
    if (usluga != null && map[usluga]) {
        const cfg = map[usluga];
        if (cfg.vel) velicinaDatoteka = state[cfg.vel];
        if (cfg.broj) brojDatoteka = state[cfg.broj];
    } else if (usluga != null) {
        // range and grouped checks
        if ((usluga >= 30 && usluga <= 47) || usluga === 60 || usluga === 61 || usluga === 62 || usluga === 104) {
            velicinaDatoteka = state.certVelicinaDatoteka;
            brojDatoteka = state.certBrojDatoteka;
        }
    }

    return { velicinaDatoteka, brojDatoteka };
}